<template>
	<div class="status-bar">
		<div class="row">
			<div class="col-sm-11 mt-1">
				<erco-dropdown class="mr-sm-5 my-2 my-lg-0"
				               label="Status"
				               :items="stati"
				               :currentItemIndex="getIndexOf(currentStatus, stati)"
				               @change="handleStatiFilterChange">
				</erco-dropdown>
				<erco-dropdown class="mr-sm-5 my-2 my-lg-0"
				               label="letzte Änderung"
				               :items="editors"
				               :currentItemIndex="getIndexOf(currentEditor, editors)"
				               @change="handleLastEditFilterChange">
				</erco-dropdown>
				<erco-dropdown class="my-2 my-lg-0"
				               label="Rubrik"
				               :items="categories"
				               :currentItemIndex="getIndexOf(currentCategory, categories)"
				               @change="handleCategoryFilterChange">
				</erco-dropdown>
			</div>

			<div class="col-sm-1">
				<erco-cms-structure-dropdown class="cms-structure-dropdown float-right"
				                             :dataset="cmsStructure"
				                             @click="handleCmsStructureClick">
				</erco-cms-structure-dropdown>
			</div>
		</div>
	</div>

</template>
<script>
	import ErcoDropdown from '@/components/molecules/ErcoDropdown';
	import ErcoCmsStructureDropdown from '@/components/atoms/ErcoCmsStructureDropdown';

	export default {
		name: 'ErcoStatusbarMolecule',
		data() {
			return {
				lastEditChange: '',
			};
		},
		methods: {
			handleStatiFilterChange(changeData) {
				const value = changeData.currentValue.trim().toLowerCase();
				const label = 'Status';

				this.handleFilter('stati', label, value, (itemValue) => {
					let isFiltered = false;
					const currentItemValue = itemValue.S_Status.trim().toLowerCase();

					/* Ein Sonderfall von Online,
					   bei dem ein Objekt sich noch nicht
					   im Veröffentlichungszeitpunkt befindet */
					switch (value) {
						case 'preview':
							isFiltered = (currentItemValue === 'online') &&
							             itemValue.isBeforeProduction;
							break;

						case 'online':
							isFiltered = itemValue.isProductive;
							break;

						default:
							isFiltered = (currentItemValue === value);
					}

					return isFiltered;
				});
			},
			handleLastEditFilterChange(changeData) {
				const value = changeData.currentValue.trim().toLowerCase();
				const label = 'letzte Änderung';

				this.lastEditChange = value;
				this.handleFilter('lastEdit', label, value, (itemValue) => {
					let currentItemValue = itemValue.S_NutzerAenderung;

					if (typeof currentItemValue === 'string') {
						currentItemValue = currentItemValue.trim().toLowerCase();
					}
					return (currentItemValue === value);
				});
			},
			handleCategoryFilterChange(changeData) {
				const value = changeData.currentValue.trim().toLowerCase();
				const label = 'Rubrik';

				this.handleFilter('category', label, value, (itemValue) => {
					let currentItemValue = itemValue.Tags;

					if (value === 'nicht zugeordnet' && !currentItemValue) {
						return true;
					}

					if (typeof currentItemValue === 'string') {
						currentItemValue = currentItemValue.split(',').map(val => val.trim().toLowerCase());
					}

					return currentItemValue && currentItemValue.includes(value);
				});
			},

			handleCmsStructureClick(data) {
				const label = 'Gattung';

				this.handleFilter('cmsStructure', label, data, (itemValue) => {
					const itemCategory = itemValue.S_Bereich && itemValue.S_Bereich.trim();
					const itemSpecification = itemValue.S_Spezifikation && itemValue.S_Spezifikation.trim();
					const itemGenus = itemValue.S_Gattung && itemValue.S_Gattung.trim();

					const matched = (itemCategory === data.category) &&
					                (itemSpecification === data.specification) &&
					                (itemGenus === data.genus);

					return matched;
				});
			},

			handleFilter(type, label, value, filterFunc) {
				if (value === null || value === 'alle') {
					this.$store.dispatch('removeDashboardFilter', type);
				} else {
					this.$store.dispatch('addDashboardFilter', {
						type,
						value,
						label,
						filterFunc,
					});
				}
			},

			getIndexOf(value, dropDownItems) {
				return dropDownItems.findIndex(item => item.value === value);
			},
		},
		components: {
			ErcoDropdown,
			ErcoCmsStructureDropdown,
		},
		computed: {
			currentStatus() {
				return (this.$store.state.dashboard.activeFilters.stati &&
				        this.$store.state.dashboard.activeFilters.stati.value) || '';
			},
			/* holt die verfügbaren Objektstati aus dem Store */
			stati() {
				const states = {
					alle: { text: 'Alle', value: 'alle' },
					preview: { text: 'Preview', value: 'preview' },
				};

				if (!this.$store.state.dashboard.objectData) {
					return [];
				}

				this.$store.state.dashboard.objectData.forEach((item) => {
					if (!item.S_Status) {
						return;
					}

					const text = (item.S_Status === '(unknown)') ? 'Unbekannt' : item.S_Status;

					const ucText = `${text.substr(0, 1).toUpperCase()}${text.substr(1)}`;
					states[item.S_Status] = { text: ucText,
						                      value: item.S_Status };
				});
				return Object.keys(states).map(key => states[key]);
			},

			currentEditor() {
				return (this.$store.state.dashboard.activeFilters.lastEdit &&
				        this.$store.state.dashboard.activeFilters.lastEdit.value) || '';
			},
			/* holt die verfügbaren Bearbeiter aus dem Store */
			editors() {
				const editors = {};

				if (!this.$store.state.dashboard.objectData) {
					return [];
				}
				this.$store.state.dashboard.objectData.forEach((item) => {
					if (item.S_NutzerAenderung) {
						editors[item.S_NutzerAenderung] = { text: item.S_NutzerAenderung,
							                                value: item.S_NutzerAenderung };
					}
				});
				const sortedEditors = Object.keys(editors).map(key => editors[key]).sort((a, b) => {
					if (a.text < b.text) {
						return -1;
					}
					if (a.text > b.text) {
						return 1;
					}
					return 0;
				});

				return [{ text: 'Alle', value: 'alle' }].concat(sortedEditors);
			},

			currentCategory() {
				return (this.$store.state.dashboard.activeFilters.category &&
				        this.$store.state.dashboard.activeFilters.category.value) || '';
			},

			/* holt die verfügbaren Rubriken aus dem Store */
			categories() {
				const categories = { };

				if (!this.$store.state.dashboard.objectData) {
					return [];
				}
				this.$store.state.dashboard.objectData.forEach((item) => {
					if (item.Tags) {
						item.Tags.split(',').forEach((tag) => {
							categories[tag] = { text: tag,
								                value: tag };
						});
					}
				});

				const sortedCategories = Object.keys(categories).map(key => categories[key]).sort((a, b) => {
					if (a.text < b.text) {
						return -1;
					}
					if (a.text > b.text) {
						return 1;
					}
					return 0;
				});

				return [{ text: 'Alle', value: 'alle' },
				        { text: 'Nicht zugeordnet', value: 'nicht zugeordnet' }]
							.concat(sortedCategories);
			},

			cmsStructure() {
				return this.$store.state.dashboard.cmsStructure.structure;
			},
		},
	};
</script>

<style lang="scss">

	.status-bar {
		vertical-align: middle;

		.dropdown-label-box {
			> .label {
				margin-right: 0.5rem;
				color: rgba(0, 0, 0, 0.5) !important;
			}
			> .dropdown {
				display: inline-block;
			}
		}

		.cms-structure-dropdown {
			margin-right: -1rem;
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoStatusbar.vue?52428684